import { ReactElement } from 'react';

import { BindingCreator } from '@dreryk/react-common';
import { RadioGroup, RadioGroupItem } from '@dreryk/react-components';

import { practitionersTranslationKeys } from '../../../../../../../../translations';

import {
   DefaultConfidentialityModeUpdateScope,
   DefaultConfidentialityModeUpdateScopeFieldFormBeanPart,
} from './DefaultConfidentialityModeUpdateScopeField.types';

const t = practitionersTranslationKeys.defaultConfidentialResourceModeUpdate;

const DEFAULT_CONFIDENTIALITY_MODE_UPDATE_SCOPE_ITEMS: RadioGroupItem<DefaultConfidentialityModeUpdateScope>[] = [
   {
      id: 'ALL_DATA',
      label: t.scope.allData,
   },
   {
      id: 'NEW_DATA_ONLY',
      label: t.scope.newDataOnly,
   },
];

type DefaultConfidentialityModeUpdateScopeFieldProps = {
   register: BindingCreator<DefaultConfidentialityModeUpdateScopeFieldFormBeanPart, 'scope'>;
};

export const DefaultConfidentialityModeUpdateScopeField = (
   props: DefaultConfidentialityModeUpdateScopeFieldProps
): ReactElement => {
   return (
      <RadioGroup<DefaultConfidentialityModeUpdateScope>
         testId={'scope'}
         items={DEFAULT_CONFIDENTIALITY_MODE_UPDATE_SCOPE_ITEMS}
         controller={props.register('scope', { required: true })}
      />
   );
};
